import Vue from 'vue';
import VueResource from 'vue-resource';
import Raven from 'raven-js';
import iOrder from '@/libs/plugins/iOrder';
import router from '@/router';

Vue.use(VueResource);

export default {

	addItemToBasket ({ state, commit, getters, dispatch }, { product, portionModifier, choicesArray }) {
		const lineItem = {
			"ingredientId": product.productId,
			"portionTypeId": portionModifier || product.defaultPortionId,
			"displayRecordId": product.displayRecordId,
			"courseId": getters['getProduct'](product.productId).defaultCourseId,
			"quantity": 1,
			"choiceLines": choicesArray || [],
			"basketKey": getters['getLineItemsAddedCount']
		};

		// Checking that the product data is complete in the Aztec menu
		const ingredientIds = [ product.productId, ...lineItem.choiceLines.map(choice => choice.ingredientId)];
		ingredientIds.forEach(id => {
			const productDetails = getters['getProduct'](product.productId);
			if (!productDetails || !productDetails.portions.find(portion => portion.id === lineItem.portionTypeId)) {
				Raven.captureBreadcrumb({
					message: 'productDetails in getBasketTotal',
					category: 'Zonal menu issue',
					data: {
						productDetails,
						ingredientId: basketLine.ingredientId
					}
				});
				Raven.captureException('Issue getting product details from aztec menu');
				dispatch('showError', { heading: 'Oops, sorry about that!', message: 'A technical error has occurred. Please ask a member of staff for help. (code:incompletemenudata)'})
				return;
			}
		});

		const matchIndex = getters['getBasketIndex'](lineItem);

		if (matchIndex !== -1) {
			commit('incrementBasketItem', { basketItemIndex: matchIndex });
		} else {
			commit('addLineItemToBasket', { lineItem });
		}
	},

	applyVoucher ({ state, commit }, { voucherCode }) {
		commit('addVoucherCodeToBasket', { voucherCode });
	},

	incrementBasketItem ({ state, commit, getters }, { product, quantity, choicesArray }) {
		const lineItem = {
			"ingredientId": product.id,
			"portionTypeId": product.portions[0].id,
			"displayRecordId": product.displayRecords[0].id,
			"courseId": product.defaultCourseId,
			"quantity": quantity,
			"choiceLines": choicesArray || []
		};

		const matchIndex = getters['getBasketIndex'](lineItem);

		if (matchIndex !== -1) {
			commit('incrementBasketItem', { basketItemIndex: matchIndex });
		} else {
			commit('addLineItemToBasket', { lineItem });
		}
	},

	clearBasket({ commit, state }) {
		commit('setBasket', { basket: { lines: [] } });
	},

	clearVoucher({ commit, state }) {
		commit('clearVoucherLines');
	},

	editBasketChoices ({ state, commit, getters }, { basketIndex, choicesArray }) {
		commit('editBasketChoices', { basketIndex, choicesArray });
	},

	setIorderConfigs ({ commit, state }) {
		commit('iOrderCheckout/setIorderConfig', 		{ config: state.config }, { root: true });
		commit('iOrderCheckout/setIorderConfig', 	{ config: state.config }, { root: true });
	},

	markItemsUnavailable ({ commit, state, getters }, { productId }) {
		const matchIndexes = getters['getBasketIndexesFromIngredientId'](productId);

		matchIndexes.forEach(basketItemIndex => {
			commit('addUnavailableFlag', { basketItemIndex });
		})
	},

	removeItemFromBasket ({ state, commit, getters }, { lineItem }) {
		const matchIndex = getters['getBasketIndex'](lineItem);

		if (state.basket.lines[matchIndex].quantity > 1) {
			commit('decrementBasketItem', { basketItemIndex: matchIndex });
		} else {
			commit('removeLineItemFromBasket', { basketItemIndex: matchIndex });
		}
	},

	removeLastMatchingProductFromBasket ({ state, commit }, { productId }) {
		const matchIndex = state.basket.lines.reduce((lastIndex, basketItem, currentIndex) => {
			return basketItem.ingredientId === productId ? currentIndex : lastIndex;
		}, 0);

		if (state.basket.lines[matchIndex].quantity > 1) {
			commit('decrementBasketItem', { basketItemIndex: matchIndex });
		} else {
			commit('removeLineItemFromBasket', { basketItemIndex: matchIndex });
		}
	},

	setTillMessage ({ state, commit, getters }) {
		const messages = [
			'ORDER PAY'
		];

		commit('clearBasketMessages');
		commit('setTillMessage', { messages });
	},

	setTableNumber ({ commit }, { tableNumber}) {
		commit('setTableNumber', { tableNumber });
	},

	showError ({ commit, state }, { heading, message }) {
		commit('setError', { heading, message });
		router.push('/error');
	},

	setVoucherDescription ({ state, commit }, { voucherDescription }) {
		commit('setValidVoucherApplied', { voucherDescription });
	},

	async validateVenueAndMenu ({ commit, state, dispatch, rootState }) {

		const siteId = rootState.site.zonalSiteId
		console.log('Starting validation process')
		commit('initJourney')

		const validVenueAndMenu = await dispatch('getVenueAndMenu')
		if (!validVenueAndMenu) {
			dispatch('showError', { heading: 'Oops, sorry about that!', message: 'Order at Table is unavailable at this time. Please place your order at the bar.(code:siteconfig)'});
			return Promise.resolve({
				success: false,
				message: 'Failed to get venue and menu'
			})
		}

		console.log('validation success')

		return Promise.resolve({
			success: true
		})
	},

	async getVenueAndMenu ({ commit, state, dispatch, rootState }) {

		const siteId = rootState.site.zonalSiteId

		const gotRestaurant = await dispatch('getRestaurantInfo');
		if (!gotRestaurant) {
			console.log(`can't find zonal restaurant data`)
			return Promise.resolve(false)
		}

		const gotTables = await dispatch('getValidTableNumbers');
		if (!gotTables) {
			console.log(`can't get tables for venue`)
			return Promise.resolve(false)
		}

		const gotMenuSummary = await dispatch('getMenuSummary', { siteId, salesAreaId: state.requiredSalesData.salesAreaId })
		if (!gotMenuSummary) {
			console.log(`can't get menu summary`)
			return Promise.resolve(false)
		}

		const gotFoodMenu = await dispatch('getMenuData', { siteId, salesAreaId: state.requiredSalesData.salesAreaId, menuId: state.requiredSalesData.foodMenuId, label: 'food' })
		if (!gotFoodMenu) {
			console.log(`can't get Food menu data`)
			return Promise.resolve(false)
		}

		const gotDrinksMenu = await dispatch('getMenuData', { siteId, salesAreaId: state.requiredSalesData.salesAreaId, menuId: state.requiredSalesData.drinksMenuId, label: 'drinks' })
		if (!gotDrinksMenu) {
			console.log(`can't get Drinks menu data`)
			return Promise.resolve(false)
		}
		return Promise.resolve(true)

	},

	async getMenuSummary ({ state, getters, commit, dispatch, rootState }, { siteId, salesAreaId }) {

		return new Promise ((resolve, reject) => {
			iOrder.getMenus({ siteId, salesAreaId, config: state.config }, (err, res) => {
				if (err) {
					dispatch('showError', { heading: 'Error returning venue menus', message: err.detail});
					return resolve(false)
				} else if (res.response === 'Error') {
					dispatch('showError', { heading: 'Error returning venue menus', message: res.detail});
					return resolve(false)
				}

				const drinksMenuIdentifier = new RegExp(rootState.site.iOrderDrinksMenuIdentifier, 'i');
				const foodMenuIdentifier = new RegExp(rootState.site.iOrderFoodMenuIdentifier, 'i');

				const foodMenu = res.menus.find(menu => foodMenuIdentifier.test(menu.name));
				const drinksMenu = res.menus.find(menu => drinksMenuIdentifier.test(menu.name));

				if (foodMenu && foodMenu.id && drinksMenu && drinksMenu.id) {
					commit('setMenuId', { drinksMenuId: drinksMenu.id, foodMenuId: foodMenu.id });
					return resolve(true)
				}
				dispatch('showError', { heading: 'Error returning venue menus', message: 'Menu is incorrectly configured'});
				return resolve(false)

			});
		})
	},

	async getMenuData ({ state, getters, commit, dispatch }, { siteId, salesAreaId, menuId, label }) {

		return new Promise ((resolve, reject) => {
			iOrder.getMenuPages({ siteId, salesAreaId, menuId, config: state.config }, (err, res) => {
				if (err) {
					dispatch('showError', { heading: 'Error returning menu data', message: err.detail});
					return resolve(false)
				} else if (res.response === 'Error') {
					dispatch('showError', { heading: 'Error returning menu data', message: res.detail});
					return resolve(false)
				}

				const canPlaceOrder = res.canPlaceOrder === 1;
				if (canPlaceOrder) {
					commit('setMenu', { label, menu: res });
					return resolve(true)
				} else {
					return resolve(false)
				}
			});
		})
	},

	getRestaurantInfo ({ state, getters, commit, dispatch, rootState }) {
		const siteId = rootState.site.zonalSiteId;

		return new Promise ((resolve, reject) => {
			iOrder.getVenue({ siteId, config: state.config }, (err, res) => {
				if (err) {
					dispatch('showError', { heading: 'Error returning venue information', message: err.detail});
					return resolve(false)
				} else if (res.response === 'Error') {
					dispatch('showError', { heading: 'Error returning venue information', message: res.detail});
					return resolve(false)
				}

				if (!res.venues.length) {
					dispatch('showError', { heading: 'Error returning venue information', message: 'No venues returned for that siteId'});
					return resolve(false)
				}

				const venueService = res.services.find(service => /drinks/i.test(service.name));
				const salesArea = res.venues[0].salesArea.find(area => /mobile|mo downstairs/i.test(area.name));
				const canPlaceOrder = res.venues[0].canPlaceOrder === 1;
				if (venueService && venueService.id && salesArea && salesArea.id && canPlaceOrder) {
					commit('setServiceId', { serviceId: venueService.id });
					commit('setSalesAreaId', { salesAreaId: salesArea.id })
					commit('setZonalVenueInfo', { restaurantData: res.venues[0] })
					commit('setZonalSiteId', { siteId: res.venues[0].id })
					return resolve(true)
				} else {
					dispatch('showError', { heading: 'Error returning venue information', message: 'Service not available' })
					return resolve(false)
				}
			});
		})
	},

	async getValidTableNumbers ({ state, getters, commit, dispatch, rootState }) {
		const siteId = rootState.site.zonalSiteId;
		const salesAreaId = state.requiredSalesData.salesAreaId;

		return new Promise ((resolve, reject) => {
			iOrder.getTables({ siteId, salesAreaId, config: state.config }, (err, res) => {
				if (err) {
					dispatch('showError', { heading: 'Error returning table information', message: err.detail});
					return resolve(false)
				} else if (res.response === 'Error') {
					dispatch('showError', { heading: 'Error returning table information', message: res.detail});
					return resolve(false)
				}
				const tables = res.map(tableObject => tableObject.number);
				if (!tables.length) {
					dispatch('showError', { heading: 'Error returning table information', message: 'No open tables returned'});
					return resolve(false)
				}
				commit('setTables', { tables })
				return resolve(tables)
			});
		})
	}
};
